import { ILibPagination } from '@infologistics/frontend-libraries';

export const paginationInitialState: ILibPagination = {
  itemsPerPage: 25,
  nextPage: null,
  pageIndex: 1,
  prevPage: null,
  total: null,
}
